////// Lib. //////
//////////////////

// ...

///// Util. //////
//////////////////

// ...

////// Hdl. //////
//////////////////

export default function eh_swup_page_load(VISITDATA = { to: { url: "" } }) {
  // Stop, if no swup visit data provided or if no to-property w/ URL present
  if (!VISITDATA || !VISITDATA.to || !VISITDATA.to.url) return;

  ////// Data-page attr. updt. ///////
  ////////////////////////////////////

  // Add attr. to document to indicate current page
  const { url } = VISITDATA.to;
  document.documentElement.setAttribute("data-page", url.split("/").pop());
}
